<template>
  <div class="saturday-roster pad height-100 pad-top-0">
  <template v-if="selectedDay !== null">
    <saturday-roster-day :day="selectedDay" @close="selectedDay = null" @updated="onDayUpdated" />
  </template>
  <template v-else>
    <div class="pad-30 center" v-if="saturdays === null">
      <fa icon="cog" size="2x" spin />
    </div>
    <div v-else class="flex">
      <div class="flex-1">
        <button class="button is-small" @click="move(-monthCount)"><fa icon="arrow-left" />&nbsp;Prev</button>
      </div>
      <div>
        <button class="button is-small" @click="move(monthCount)">Next&nbsp;<fa icon="arrow-right" /></button>
      </div>
    </div>

    <div class="month" v-for="(month, monthKey) in saturdays" :key="monthKey">
      <table class="table is-striped is-hoverable is-bordered roster margin-bottom-20">
        <thead>
          <tr>
            <th colspan="2">{{ monthKey }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(day, timestamp) in month" :key="timestamp" :class="getSatClass(day)" @click="onSelectDay(day)">
            <th>{{ timestamp | unixToDateString }}</th>
            <td>
              <template v-if="saturdayRosterDays === null">
                <fa icon="cog" class="has-text-grey-light" spin />
              </template>
              <template v-else-if="day.user">
                <p class="rostered">{{ day.user.firstName }} {{ day.user.lastName }}</p>
                <template v-if="day.swapRequestUser">
                  <p class="pad-left-5 font-size-70">swap requested to</p>
                  <p class="pad-left-5 font-size-80">{{ day.swapRequestUser.firstName }} {{ day.swapRequestUser.lastName }}</p>
                </template>
              </template>
              <template v-else-if="day.closed">
                <span class="not-rostered bold has-text-grey-light">CLOSED</span>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  <br /><br />

  </div>
</template>

<script>
import SaturdayRosterDay from '@/components/SaturdayRosterDay'

export default {
  name: 'SaturdayRoster',
  components: {
    SaturdayRosterDay
  },
  data () {
    return {
      nextSat: null,
      satBeforeNextSatTimestamp: null,
      fromTimestamp: 0,
      toTimestamp: 0,
      monthCount: 3,
      saturdays: null,
      saturdayRosterDays: null,
      selectedDay: null,
      dateFormat: 'YYYY_MM_DD',
      dayFrom: null,
      dayTo: null
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    isAdmin () { return this.user && this.user.privileges.includes('saturday roster admin') }
  },
  created () {
    this.fromTimestamp = this.$moment().startOf('month').unix()
    this.fetchRosterDays()
  },
  methods: {
    onDayUpdated (day, action) {
      console.log(action, day)
      this.selectedDay = day
    },
    move (monthInc) {
      this.fromTimestamp = this.$moment.unix(this.fromTimestamp)
        .add(monthInc, 'months')
        .unix()
      this.fetchRosterDays()
    },
    getSatClass (day) {
      let timestamp = Number(day.timestamp)
      let classes = []
      if (day.user && day.user._id === this.user._id) classes.push('me')
      if (timestamp > this.nextSatTimestamp) classes.push('future')
      else if (timestamp < this.nextSatTimestamp) classes.push('past')
      else classes.push('next')

      if (timestamp === this.satBeforeNextSatTimestamp) classes.push('sat-before-next')
      return classes
    },
    handleRosterDaysSnapshot (snapshot) {
      let rosterDays = this.$utils.snapshotToObjMap(snapshot) || {}

      let sats = {}
      let m = this.$moment.unix(this.fromTimestamp).day(6)
      let timestamp = m.unix()
      while (timestamp < this.toTimestamp) {
        let monthKey = m.format('MMMM')
        let month = sats[monthKey]
        if (!month) {
          month = {}
          sats[monthKey] = month
        }
        month[timestamp] = rosterDays[timestamp] || {
          timestamp,
          user: null,
          swapRequestUser: null,
          closed: false,
          history: []
        }
        m.add(1, 'week')
        timestamp = m.unix()
      }
      this.saturdays = sats
      this.saturdayRosterDays = rosterDays
    },
    getRosterDay (timestamp) {
      if (!this.saturdayRosterDays) return null
      return this.saturdayRosterDays[timestamp] || null
    },
    fetchRosterDays (snapshot) {
      this.saturdays = null
      this.saturdayRosterDays = null

      this.toTimestamp = this.$moment.unix(this.fromTimestamp)
        .add(this.monthCount, 'months')
        .unix()

      let m = this.$moment().day(6).startOf('day')
      this.nextSatTimestamp = m.unix()
      m.add(-7, 'days')
      this.satBeforeNextSatTimestamp = m.unix()

      this.unsub('saturdayRosterDays')
      this.subs.saturdayRosterDays = this.$firestore.collection('saturdayRosterDays')
        .where('timestamp', '>=', this.fromTimestamp)
        .where('timestamp', '<=', this.toTimestamp)
        .orderBy('timestamp', 'asc')
        .onSnapshot(this.handleRosterDaysSnapshot)
    },
    onSelectDay (day) {
      this.selectedDay = day
    }
  }
}
</script>

<style>
  .saturday-roster table.roster tr th {
    width: 1px;
    background-color: #eee;
    border-right: solid 2px #666;
    border-left: solid 2px #666;
  }

  /* .saturday-roster table.roster tr.me th, */
  .saturday-roster table.roster tr.me td {
    font-weight:  bold;
    font-size: 1.2em;
  }

  .saturday-roster table.roster tr:first-child th {
    border-top: solid 2px #666;
  }
  .saturday-roster table.roster tr:last-child th {
    border-bottom: solid 2px #666;
  }

  .saturday-roster table.roster tr.past {
    opacity: 0.5;
  }

  .saturday-roster table.roster tr.next td {
    border-bottom: solid 2px blue;
    border-right: solid 2px blue;
  }

  .saturday-roster table.roster tr.next th {
    border-bottom: solid 2px blue;
    border-left: solid 2px blue;
  }

  .saturday-roster table.roster tr.sat-before-next th,
  .saturday-roster table.roster tr.sat-before-next td {
    border-bottom: solid 2px blue;
  }

</style>
